// Chakra imports
import { Box, Flex, Image, Text, useColorModeValue } from "@chakra-ui/react";

// Custom components
import { HSeparator } from "../../../components/separator/Separator";
import  logo  from "../../../assets/img/header_rogo 1.png";

export function SidebarBrand(props: { mini: boolean; hovered: boolean }) {
  const { mini, hovered } = props;
  //   Chakra color mode
  let logoColor = useColorModeValue("navy.700", "white");

  return (
    <Flex alignItems="center" flexDirection="column">
      <Box
        h="100%"
        w="175px"
        mb="32px"
        color={logoColor}
        display={
          mini === false
            ? "block"
            : mini === true && hovered === true
            ? "block"
            : "none"
        }
      >
        <Image
          src={logo}
          alt="header_rogo"
          width="50px"
          height="50px"
        />
      </Box>
      <Text
        display={
          mini === false
            ? "none"
            : mini === true && hovered === true
            ? "none"
            : "block"
        }
        fontSize={"30px"}
        fontWeight="800"
        color={logoColor}
      >
        H
      </Text>
      <HSeparator mb="20px" />
    </Flex>
  );
}

export default SidebarBrand;
